// removed by extract-text-webpack-plugin
module.exports = {"geolocation":"_2aGfvktgJwZ0yGi7Gqp11B"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/PickupLocator/Geolocation/geolocationStyles.scss
// module id = 909
// module chunks = 0